import { crewPositionLabel } from '../../../../../lib/crewPositions';
import { Avatar, StatusPill } from '../../../primitives';
import type { TeacherEntry } from '../../regionalApi';

import { EM_DASH } from './roster-shared';

export default function TeacherRosterTable({
  teachers,
}: {
  teachers: ReadonlyArray<TeacherEntry>;
}) {
  return (
    <table className="nb-tbl">
      <thead>
        <tr>
          <th>Teacher</th>
          <th>Role</th>
          <th>Rate</th>
          <th>This wk</th>
          <th>Month</th>
          <th>POS sales</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {teachers.map((t) => (
          <tr key={t.userId}>
            <td>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <Avatar name={t.name} color={t.avatarColor} size={22} />
                <span style={{ fontWeight: 600 }}>{t.name}</span>
              </div>
            </td>
            {/* BON-420 — was a lone ternary that rendered every other role
                as its raw lowercase value ('teacher', 'assistant'). */}
            <td className="nb-muted">{crewPositionLabel(t.role)}</td>
            <td className="nb-tabular nb-mono">
              {/* TODO(BON-144): rate per hour needs payroll. */}
              {t.ratePerHr === null ? EM_DASH : `$${t.ratePerHr}/hr`}
            </td>
            <td className="nb-tabular nb-mono">{t.workshopsThisWeek}</td>
            <td className="nb-tabular nb-mono">{t.workshopsMtd}</td>
            <td className="nb-tabular nb-mono">
              {t.posSalesMtd === null
                ? EM_DASH
                : `$${Math.round(t.posSalesMtd / 100).toLocaleString('en-US')}`}
            </td>
            <td>
              <StatusPill tone={t.availability} />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
